import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';
import { getCardById } from '../use';
import { SetAssigneeOnCard } from '@/api/storymapCardDetails/commands';
import { useSendCommand } from '@/_core/cqrs/use';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class AddAssigneeToCard extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'AddAssigneeToCard';

    public constructor(public cardId: string, public assigneeUserId: string, public isDispatchedByDetailsModal: boolean = false) {
        super(AddAssigneeToCard.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: AddAssigneeToCard): Promise<boolean> => {
    if (action.isDispatchedByDetailsModal) {
        return true;
    }

    const card = getCardById(action.cardId);
    const collaborator = state.collaborators.find((x) => x.userId === action.assigneeUserId);
    const oldCollaborator = state.collaborators.find((x) => x.userId === card.assigneeUserId);

    const command = await SetAssigneeOnCard.create(card.id, card.title, state.id, collaborator, oldCollaborator);

    return useSendCommand(action, {
        createCommand: () => command,
    });
};

const reducer = (state: StorymapState, action: AddAssigneeToCard): void => {
    const card = getCardById(action.cardId);
    card.assigneeUserId = action.assigneeUserId;
};

//@ts-ignore
registerMiddleware(AddAssigneeToCard.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(AddAssigneeToCard.ACTION_TYPE, reducer);
